export default {
  computed: {
    settingDefaultsMap () {
      return this.buildSettingDefaultsMap()
    }
  },
  data () {
    return {
      clubSettingDefaults: []
    }
  },
  methods: {
    buildSettingDefaultsMap () {
      return this.clubSettingDefaults.reduce((map, setting) => {
        map[setting.name] = setting
        return map
      }, {})
    },
    clubSettingDefaultsCommand () {
      const params = {
        children: true,
        filter: [ // Filter out any that we only have view access for
          {field: 'allowClubMod', operator: 'EQUAL', values: [true]},
          {condition: 'OR', field: 'allowForeteeAdminMod', operator: 'EQUAL', values: [true]}
        ],
        filter_methods: {filterHiddenSettings: [true]}
      }
      const filter_methods = {}
      filter_methods.filterHiddenSettings = [true]
      if (this.selectedItemId) {
        filter_methods.filterByClubSetting = [[this.selectedItemId]]
      }
      params.filter_methods = filter_methods
      return [
        {
          command: 'clubSettingDefault',
          resultFilter (data) {
            if (!this.showItem) return data // We don't need to filter this if showing in listing page
            // Filter options setting any undefined values to null
            // - This is to allow settings with a null value to match options with a null value
            // - Gson, by default, removes any null values from the payload sent to us, so they appear undefined.
            for (let record of data) {
              if (record.options) {
                for (let option of record.options) {
                  if (option.value === undefined) option.value = null
                }
              }
            }
            return data
          },
          load: this.clubSettingDefaults,
          loading: this.setIsLoading,
          params: params
        }
      ]
    },
    getDefaultSetting (name) {
      return this.settingDefaultsMap[name] || {}
    }
  }
}
